import { ImageDetailsList, ImageListItem } from "./image-details-list";
import React, { useContext } from "react";
import { TaskContext } from "../../../../contexts/task";
import { NO_IMAGE_URL } from "../../lib/constants";

export const ProductDetails = ({ productShots }) => {
    const { task } = useContext(TaskContext);

    return (
        <ImageDetailsList className="images-details-list">
            <ImageListItem className="image-info -small-box">
                <h4>Intake Product</h4>
                <div className="details">
                    <span className="txt-bold">Product ID</span>
                    <span>{task.context.correlationId}</span>
                </div>
            </ImageListItem>
            <ImageListItem className="images flex-row">
                <ImageDetailsList className="product-images">
                    {productShots.map((shot, shotIndex) => {
                        return (
                            <ImageListItem
                                key={shot ? shot.key : shotIndex}
                                className="product-image-item"
                            >
                                <div className="product-image-container">
                                    <img
                                        className="image"
                                        alt={shot ? shot.imageViewDescription : shotIndex}
                                        src={shot ? shot.editedImageUris.medium : NO_IMAGE_URL}
                                    />
                                </div>
                                <h5>
                                    {shot.imageViewDescription || shot.imageView} <span>{shot.locale}</span>
                                </h5>
                            </ImageListItem>
                        );
                    })}
                </ImageDetailsList>
            </ImageListItem>
        </ImageDetailsList>
    );
};
